var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5ZM13.5805 8.47493C13.8428 8.15434 13.7955 7.68183 13.4749 7.41953C13.1543 7.15724 12.6818 7.20449 12.4195 7.52507L8.44432 12.3837L7.03033 10.9697C6.73744 10.6768 6.26256 10.6768 5.96967 10.9697C5.67678 11.2626 5.67678 11.7374 5.96967 12.0303L7.96967 14.0303C8.1195 14.1802 8.32573 14.2596 8.53736 14.2491C8.74899 14.2385 8.94629 14.1389 9.08047 13.9749L13.5805 8.47493Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.351ffe44fa5ec3ae49aac79cd56fe4f0.svg";
export { ForwardRef as ReactComponent };